
<template>
  <div>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <v-text-field v-model="user_attributes.name" :readonly="read_only" :rules="[...required]"  
           label="Nome" class="ma-2" prepend-icon="mdi-account" @change="verify()">
          </v-text-field>
        </v-col>
        <v-col cols="12" :md="has_email ? '5' : '12'">
          <v-text-field v-model="user_attributes.cpf" :rules="cpf" :readonly="read_only" 
           label="CPF" class="ma-2" prepend-icon="mdi-clipboard-account" v-mask="'###.###.###-##'" lazy>
          </v-text-field>
        </v-col>
        <v-col cols="12" md="7">
          <v-text-field v-if="has_email" v-model="user_attributes.email" :rules="emailRules" :readonly="read_only" 
          label="Email" class="ma-2" prepend-icon="mdi-email" lazy>
          </v-text-field>
        </v-col>
        <v-col cols="12" v-if="teamModel">
          <v-select
            v-model="teamModel.team"
            :items="teamOptions"
            :readonly="read_only"
            item-text="text"
            item-value="value"
            label="Time"
            class="ma-2"
            prepend-icon="mdi-account-group"
            :rules="[...required]"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import validations from "@/mixins/validations"

export default {
  name: 'EmployeeInfoForm',
  mixins: [ validations ],
  props: {
    user_attributes:{
      type: Object,
      default: () => {return {}}
    },
    teamModel:{
      type: Object,
      default: null,
    },
    read_only:{
      type: Boolean,
      default:false,
    },
    has_email:{
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      teamOptions: [
        { text: 'Sem time', value: 'none' },
        { text: 'Metropolitana', value: 'metropolitana' },
        { text: 'Expansão Minas', value: 'expansao_minas' },
        { text: 'Triangulo', value: 'triangulo' },
      ],
    }
  },
  methods: {
    validate(){
      return this.$refs.form.validate()
    },
    verify() {
      // this.allEmployees.data.forEach(e => {
      //   if (e.attributes.name.toLocaleUpperCase() == this.employee.user_attributes.name.toLocaleUpperCase()) {
      //     this.addNotification({type: 'error',  msg: 'Funcionário "' + e.attributes.name + '" já cadastrado'})
      //     this.employee.user_attributes.name = null
      //   }
      // });
    },
  },
}
</script>
